export default "__VITE_ASSET__8WDsH2iA__"